import { useRef, useState } from "react";
import { ArrowUp, Swords } from "lucide-react";

const RADIUS = 52;

const Joystick = ({ game, classic }) => {
  const base = useRef(null);
  const pid = useRef(null);
  const [knob, setKnob] = useState({ x: 0, y: 0 });

  const apply = (dx, dy) => {
    const g = game.current;
    if (!g) return;
    const dead = RADIUS * 0.3;
    g.input.left = dx < -dead;
    g.input.right = dx > dead;
    g.input.up = dy < -dead;
    g.input.down = dy > dead;
    if (!classic) {
      const up = dy < -RADIUS * 0.6;
      if (up && !g.input.stickJump) g.queueJump?.();
      g.input.stickJump = up;
    }
  };

  const move = (e) => {
    if (pid.current !== e.pointerId) return;
    const r = base.current.getBoundingClientRect();
    let dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
    const d = Math.hypot(dx, dy);
    if (d > RADIUS) { dx = (dx / d) * RADIUS; dy = (dy / d) * RADIUS; }
    setKnob({ x: dx, y: dy });
    apply(dx, dy);
  };

  const end = (e) => {
    if (pid.current !== e.pointerId) return;
    pid.current = null;
    setKnob({ x: 0, y: 0 });
    apply(0, 0);
  };

  return (
    <div
      ref={base}
      className="joystick"
      data-testid="touch-joystick"
      onPointerDown={(e) => { e.preventDefault(); e.stopPropagation(); pid.current = e.pointerId; e.currentTarget.setPointerCapture(e.pointerId); move(e); }}
      onPointerMove={move}
      onPointerUp={end}
      onPointerCancel={end}
      onLostPointerCapture={end}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div className="joystick-knob" style={{ transform: `translate(${knob.x}px, ${knob.y}px)` }} />
    </div>
  );
};

const Btn = ({ k, game, children, className = "" }) => {
  const down = (e) => {
    e.preventDefault(); e.stopPropagation();
    e.currentTarget.setPointerCapture(e.pointerId);
    const g = game.current;
    if (!g) return;
    if (k === "jump") g.queueJump?.();
    g.input[k] = true;
  };
  const up = (e) => { e.preventDefault(); if (game.current) game.current.input[k] = false; };
  return (
    <button
      className={`touch-btn ${className}`}
      data-testid={`touch-${k}-button`}
      onPointerDown={down}
      onPointerUp={up}
      onPointerCancel={up}
      onLostPointerCapture={up}
      onContextMenu={(e) => e.preventDefault()}
    >
      {children}
    </button>
  );
};

export const TouchControls = ({ game, classic }) => (
  <div className="touch-controls" data-testid="touch-controls">
    <Joystick game={game} classic={classic} />
    <div className="action-pad">
      {!classic && <Btn k="jump" game={game} className="jump"><ArrowUp size={30} /></Btn>}
      <Btn k="atk" game={game} className="atk"><Swords size={30} /></Btn>
    </div>
  </div>
);
